import React, { useEffect, useState } from 'react'
import "../Styles/Shome.css"
import { useDispatch, useSelector } from 'react-redux'
import { get_category, post_category, post_item } from '../Redux/Actions/adminAction'

const Administration = () => {
    const [form, setForm] = useState(true)
    const [form2, setForm2] = useState(false)
    const [image, setImage] = useState("")
    const [file, setFile] = useState("")
    
    const [from, setFrom] = useState("")
    const [esession, setESession] = useState("")
    const [day, setDay] = useState("")
    const [event, setEvent] = useState("")
    function previewFiles(file){
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = ()=>{
            setImage(reader.result)
        }
    }
    const handleChange = (e) => {
        const file = e.target.files[0]
        setFile(file)
        previewFiles(file)
    }
    const eshandleSelectChange = (e) => {
        setESession(e.target.value)
    };
    const getCategory = useSelector((state) => state.getCategory)
	const { categoryDetail } = getCategory
    // const getAllSession = useSelector((state) => state.getAllSession)
	// const { allsession } = getAllSession
    
    const dispatch = useDispatch()
    
    const submitHandler = (e) => {
        e.preventDefault()
        dispatch(post_category({name: from}))
    }
    
    const eventSubmitHandler = (e) => {
        e.preventDefault()
        const item = {
            category: esession,
            image,
			name: day,
			availability: true,
            details: event,
        }
        dispatch(post_item(item))
    }
    const hideForm = ()=>{
        dispatch(get_category())
        setForm(true)
        setForm2(false)
    }
    const hideForm2 = ()=>{
        dispatch(get_category())
        setForm(false)
        setForm2(true)
    }
  return (
    <>
        <main className='container-fluid shomain'>
            <p className='shopsash2 mb-0'>Product Management</p>
            <p className='swafundpayacc mt-2 mb-0'>Category & Product</p>
            <div className='row'>
                <div className='col-md-12 mt-3'>
                    <div className='swalfunbs'>
                        <div className='d-flex swalfunaic'>
                            <div className='swalfunsbbs'></div>
                            <p className='mb-0 ms-2 swalfunp1'>Post</p>
                        </div>
                        <div className='p-3'>
                            <fieldset className='border swalfunfs px-3 pb-3'>
                                <legend className='swalfunlegend2 ms-4'>
                                    <div className="btn-group border btn-group-sm">
                                        <button type="button" className="btn btn-white border-end" onClick={hideForm}>Create Category</button>
                                        <button type="button" className="btn btn-white border-start" onClick={hideForm2}>Create Item</button>
                                    </div>
                                </legend>
                                {form &&
                                <form onSubmit={submitHandler} className='ateafo2'>
                                    <h3 className='mt-5 '>Category Details</h3>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <p className='swalfunp2 mt-3'>Name:</p>
                                            <input type='text' value={from} onChange={(e) => setFrom(e.target.value)}  className='swalfunselact form-control form-select-sm'/>
                                        </div>
                                    </div>
                                    <button type='submit' className='subbtn3 mt-5 px-3'>Submit</button>
                                </form>
                                }
                                {form2 &&
                                <form onSubmit={eventSubmitHandler} className='ateafo2'>
                                    <h3 className='mt-5 '>Item Details</h3>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <p className='swalfunp2 mt-3'>Category</p>
                                            <select onChange={eshandleSelectChange} className='swalfunselact form-select form-control form-select-sm'>
                                                <option>Select Category</option>
                                                {categoryDetail && categoryDetail.map((as) =>
                                                <option key={as._id} value={as._id}>{as.name}</option>
                                                )}
                                            </select>
                                        </div>
                                        <div className='col-md-6'>
                                            <p className='swalfunp2 mt-3'>Title:</p>
                                            <input type='text' value={day} onChange={(e) => setDay(e.target.value)}  className='swalfunselact form-control form-select-sm'/>
                                        </div>
                                        <div className='col-md-6'>
                                            <p className='swalfunp2 mt-3'>Details:</p>
                                            <textarea type='text' value={event} onChange={(e) => setEvent(e.target.value)}  className='swalfunselact form-control form-select-sm'/>
                                        </div>
                                        <div className='col-md-6'>
                                            <p className='swalfunp2 mt-3'>Image:</p>
                                            <input type="file" required accept='image/png, image/jpeg, image/jpg, image/jfif' className='swalfunselact form-control form-select-sm' onChange={e=>handleChange(e)}/>
                                        </div>
                                        {image &&
                                        <div className='col-md-6'>
                                            <img className='mt-5' style={{width:"100px",height:"100px",borderRadius:"50%"}} src={image}/>
                                        </div>}
                                    </div>
                                    <button type='submit' className='subbtn3 mt-5 px-3'>Submit</button>
                                </form>
                                }
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </>
  )
}

export default Administration